// a helpful interface for organizing the status of template fragments

import { BareSailingDay, SailingDay } from '@go-shared/types/sailing';

// says if they exist, and if so, if they are history or actual linked ones
type TemplateStatusType = 'linked' | 'history';

export interface TemplateStatus {
  events?: TemplateStatusType;
  venueData?: TemplateStatusType;
  feed?: TemplateStatusType;
  content?: TemplateStatusType;
}

export function extractTemplateStatus(sailingDay?: BareSailingDay | SailingDay) {
  const templateFragments = sailingDay ? sailingDay.templateFragments : undefined;
  const templateHistory = sailingDay ? sailingDay.templateHistory : undefined;

  const templateStatus: TemplateStatus = {
    events:
      templateFragments && templateFragments.events
        ? 'linked'
        : templateHistory && templateHistory.events
        ? 'history'
        : undefined,
    venueData:
      templateFragments && templateFragments.venueData
        ? 'linked'
        : templateHistory && templateHistory.venueData
        ? 'history'
        : undefined,
    content:
      templateFragments && templateFragments.content
        ? 'linked'
        : templateHistory && templateHistory.content
        ? 'history'
        : undefined,
    feed:
      templateFragments && templateFragments.feed
        ? 'linked'
        : templateHistory && templateHistory.feed
        ? 'history'
        : undefined,
  };

  return { templateStatus, templateFragments, templateHistory };
}
